import * as React from "react"
import { EmptyState } from "gatsby-interface"
import { notificationDeploys as notificationDeploysText } from "@modules/locales/default.js"
import { CloudResourceType } from "@modules/graphql/types"
import { useNotificationIntegrationsQuery } from "@modules/notifications/deploys/queries.generated"
import Loading from "@modules/ui/components/Loading"
import { NotificationIntegrationRow } from "./NotificationIntegrationRow"
import { ErrorAlert } from "@modules/ui/components/ErrorAlert"

export type NotificationDeploysProps = {
  resourceId: string
  resourceType: CloudResourceType
}

export function NotificationDeploys({
  resourceId,
  resourceType,
}: NotificationDeploysProps) {
  const { loading, data, error } = useNotificationIntegrationsQuery({
    variables: { resourceId, resourceType },
  })

  if (loading) {
    return (
      <Loading
        variant="baby"
        message={notificationDeploysText.messages.loadingNotificationDeploys}
      />
    )
  }

  if (error) {
    return <ErrorAlert>{error.message}</ErrorAlert>
  }

  if (data?.notificationIntegrations?.length === 0) {
    return (
      <EmptyState
        variant="WITH_BACKGROUND"
        heading={notificationDeploysText.headers.noNotificationIntegrations}
        text={notificationDeploysText.messages.addNewIntegration}
      />
    )
  }

  const notificationIntegrations = data?.notificationIntegrations || []

  return (
    <ul css={{ padding: 0, margin: 0, listStyleType: "none" }}>
      {notificationIntegrations.map(notificationIntegration => (
        <li
          key={`notification-deploy-${notificationIntegration.id}`}
          css={theme => ({
            margin: 0,
            padding: `${theme.space[3]} 0`,
          })}
        >
          <NotificationIntegrationRow
            notificationIntegration={notificationIntegration}
            resourceId={resourceId}
            resourceType={resourceType}
          />
        </li>
      ))}
    </ul>
  )
}
